import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import {
  TextColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import { hideScrollbars } from '@picsart/design-system/styleUtils/hideScrollbars';

const CARD_WIDTH = 156;

const useStyles = createUseStyles(
  {
    section: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s12,
      marginBottom: Spacings.s24,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: Spacings.s16,
      paddingRight: Spacings.s16,
    },
    title: {
      fontSize: FontSizes.t5,
      lineHeight: LineHeights.t5,
      fontWeight: FontWeights.bold,
      color: TextColors.base,
      margin: 0,
    },
    seeAllButton: {
      color: PrimaryColors.base.default,
    },
    row: {
      display: 'flex',
      gap: Spacings.s12,
      overflowX: 'auto',
      overflowY: 'hidden',
      paddingLeft: Spacings.s16,
      paddingRight: Spacings.s16,
      scrollPaddingLeft: Spacings.s16,
      scrollPaddingRight: Spacings.s16,
      scrollSnapType: 'x proximity',
      WebkitOverflowScrolling: 'touch',
      ...hideScrollbars,
    },
    cell: {
      flex: '0 0 auto',
      width: CARD_WIDTH,
      aspectRatio: '3 / 4',
      scrollSnapAlign: 'start',
    },
  },
  { name: 'CategoryRow' }
);

export default useStyles;
